export { default } from "./SponsorTopBanner";
